<template>
    <LayoutWithContainer>
        <template slot="header">
            <ContentHeader title="Sectors" :bordered="false">
                <template slot="actions">
                    <router-link to="/sectors/add" class="btn btn--primary" v-if="can('createMembers')">Add Sector</router-link>
                </template>
            </ContentHeader>
        </template>
        <SectorGrid />
    </LayoutWithContainer>
</template>

<script>
    import { mapGetters } from 'vuex';
    import LayoutWithContainer from '@layouts/LayoutWithContainer';
    import SectorGrid from '@components/Sector/Grid/Grid';
    import ContentHeader from '@components/Header/ContentHeader';
    import FormControlDynamicSector from '@components/Form/Control/FormControlDynamicSector';

    export default {
        name: 'SectorList',
        components: {
            FormControlDynamicSector,
            ContentHeader,
            LayoutWithContainer,
            SectorGrid
        },
        computed: {
            ...mapGetters([
                'can',
            ]),
        }
    }
</script>
